import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';
import { Link } from 'react-router-dom';

function ErrorPage() {
  return (
    <Box height="500px" display="flex" padding="5%" flexDirection="column" gap={2}>
      <Typography variant="h1" mb={1}>
        Oops!
      </Typography>
      <Typography variant="h4" mb={2}>
        Sorry, an unexpected error has occurred.
      </Typography>
      <Link to="/">Retour à l&apos;accueil</Link>
    </Box>
  );
}

export default ErrorPage;
